import React from 'react';
import RowAccountPickerField from '@/components/document-entry/RowAccountPickerField';
import type { HeadingFlat } from '@/document-entry/headingCatalog';
import type { PayrollDocSettings } from '@/lib/payroll/payrollDocSettings';

type PayrollDocSettingsFieldsProps = {
  settings: PayrollDocSettings;
  onChange: (patch: Partial<PayrollDocSettings>) => void;
  headingCatalog: HeadingFlat[];
  disabled?: boolean;
};

const PayrollDocSettingsFields: React.FC<PayrollDocSettingsFieldsProps> = ({
  settings,
  onChange,
  headingCatalog,
  disabled,
}) => (
  <div className="grid gap-4 sm:grid-cols-2">
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-800">
        حساب بستانکار — بدهی حقوق به پرسنل
      </label>
      <p className="mb-2 text-xs text-slate-500">کل، معین یا تفصیلی — برای همهٔ ردیف‌های بستانکار</p>
      <RowAccountPickerField
        mode="accountOnly"
        accountCode={settings.payable_account_code}
        onAccountCodeChange={(code) => onChange({ payable_account_code: code })}
        headingCatalog={headingCatalog}
        disabled={disabled}
      />
    </div>
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-800">حساب بدهکار — هزینه حقوق</label>
      <p className="mb-2 text-xs text-slate-500">برای ردیف‌های بدهکار به تفکیک پروژه</p>
      <RowAccountPickerField
        mode="accountOnly"
        accountCode={settings.expense_account_code}
        onAccountCodeChange={(code) => onChange({ expense_account_code: code })}
        headingCatalog={headingCatalog}
        disabled={disabled}
      />
    </div>
  </div>
);

export default PayrollDocSettingsFields;
